<template>
  <div v-wechat-title="title"
  style="height:100%;padding:10px ;background: #C0C4CC;display:flex;align-items: center;justify-content: center; "
  class="docframe" :loadiing="loading">
      <pdf
          v-for="i in numPages"
          :key="i"
          :src="src"
          :page="i"
          style="width:100%"
      ></pdf>
  </div>
</template>
<script>
import pdf from '@/common/vue-pdf-4.1.0'
// var loadingTask = pdf.createLoadingTask('../../static/pdf/199v2_1000_27_1_正常_202003080000_202003080000_164F6D3048490F345A85C6D61E85518B_4F3342BF80A487718F8A017C0B999EA3.pdf');
export default {
    name: `AnesthesiaRecords`,
    components: { pdf },
    props: {

    },
    data() {
        return {
            title: `麻醉记录`,
            surgeryId: this.$route.query.surgery_id,
            loading: false,
            numPages: 0,
            src: ``
        }
    },
    computed: {

    },
    mounted() {
        this.loading = true
        this.$store.dispatch(`LOAD_PDF_DATA`, { host: this.$root.DOCSERVICE_BASE,
            params: Object.assign({
                docid: 357,
                from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                id1: this.surgeryId,
                id3: 1
            }, this.extraParams) }).then(data => {
            this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
            this.src.then(content => {
                this.numPages = content.numPages
                this.loading = false
            })
        }).catch(e => {
            this.loading = false
        })
        // axios.get("http://192.168.0.136:50400/doc3.ashx/file?uri=/outputs/357v10_555_1_1_%E6%AD%A3%E5%B8%B8_202005270812_202005270812_31D556B0138D6916CD2362FB5E77F58D_3598BB46919E1D6C0EEEE974A5A31FDE.pd?type=base64&r="+Math.random()).then(data=>{
        //   loading.close()
        //   this.src =pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
        //   this.src.then(content => {
        //       this.numPages = content.numPages
        //       this.loading =false
        //   })
        // }).catch(e=>console.log(e))
    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Surgery/AnesthesiaRecords/Index.vue